import React, { useCallback } from "react";
import clsx from "clsx";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../../styles/theme";
import javascriptHandler from "../../apis/javascriptHandler";
import { AdBannerData } from "../../types";

interface Props {
   data: AdBannerData;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      height: 110,
      borderTopRightRadius: 20,
      borderTopLeftRadius: 20,
   },
   text: {
      position: "absolute",
      padding: "29px 0px 29px 26px",
      width: "100vw",
      height: "11rem",
   },
   title: {
      width: "calc(100% - 142px)",
      fontSize: "1.8rem",
      color: theme.mono0,
      marginBottom: 2,
      wordBreak: "keep-all",
   },
   subTitle: {
      width: "calc(100% - 142px)",
      fontSize: "1.4rem",
      color: theme.mono50,
   },
   titleOnly: {
      fontSize: "1.6rem",
   },
   img: {
      width: "auto",
      height: "inherit",
   },
}));

const AdBanner: React.FC<Props> = ({ data }) => {
   const classes = useStyles();
   const { link = "", title, subTitle, img } = data;

   const handleClick = useCallback(() => {
      if (!!link) {
         javascriptHandler._callHandler("OpenWebView", link);
      }
   }, [link]);

   return (
      <div onClick={() => handleClick()} className={classes.wrap}>
         <div className={classes.text}>
            <p className={clsx(classes.title, !subTitle && classes.titleOnly)}>
               {title}
            </p>
            <p className={classes.subTitle}>{subTitle}</p>
         </div>
         <img className={classes.img} src={img} alt={title} />
      </div>
   );
};

export default AdBanner;
